import ColumnBase from "./ColumnBase.jsx";
import {WIDGET_KEYS} from "../../other/constants/WidgetKeys.jsx";
import {commentIconDefaultString} from "../../other/utils/utils.jsx";
import {ColumnStore} from "@bryntum/schedulerpro";
import { ICON_COL_DEF_WIDTH } from "../../other/constants/OtherKeys.jsx";

export default class CommentColumn extends ColumnBase {
  static get $name() {
    return "CommentColumn";
  }

  static get type() {
    return WIDGET_KEYS.commentColumn
  }

  static get defaults() {
    return {
      text: "Comment",
      width: 30,
      autoHeight: true,
      align: "center",
      minWidth: ICON_COL_DEF_WIDTH,
      headerRenderer() {
        return commentIconDefaultString();
      },
      editor: {
        type: "textarea"
      }
    }
  }
}

ColumnStore.registerColumnType(CommentColumn);
